
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms_and_conditions",
      function () {
        return require("private-next-pages/terms_and_conditions.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms_and_conditions"])
      });
    }
  